import React, { Component } from 'react';
import Profilecomponent from '../../common/profilecomponent';
import BecasContainer from './BecasContainer';
import SweetAlert from 'sweetalert2-react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TabContent, TabPane, Nav, NavLink, NavItem } from "reactstrap";
import classnames from 'classnames';
import Dropzone from '../../common/DropzoneExample';


import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';

import { Link } from "react-router-dom";

class Becas extends Component {

	constructor(props) {
		super(props);
		this.state = {
			activeTab: 1,
			show: false,
		};
	}

	render() {
		const { activeTab } = this.state
		return (
			<>
				<div className="section-body">
					<div className="container-fluid">
						<div className="d-flex justify-content-between align-items-center ">
							<div className="header-action">
								<h1 className="page-title">Becas</h1>
								<ol className="breadcrumb page-breadcrumb">
									<li className="breadcrumb-item"><a href="#">Administrativo</a></li>
									<li className="breadcrumb-item active" aria-current="page">Listado De Alumnos Con Beca</li>
								</ol>
							</div>

						</div>
					</div>
				</div>

				<div className="section-body mt-4">
					<div className="container-fluid">
						<TabContent activeTab={activeTab}>

							<TabPane tabId={1} className={classnames(['fade show'])}>
								<BecasContainer />
							</TabPane>

						</TabContent>
					</div>
				</div>

			</>
		);

	}//END RENDER


}//END CLASS

export default Becas
//export default withRouter(connect(mapStateToProps, null)(Becas));
